<template>
  <div class="bg-light">
    <!-- Header -->
    <Header></Header>

    <!-- Main Content -->
    <main class="container my-4">
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="position-relative m-4">
            <div class="progress" style="height: 3px;">
              <div class="progress-bar bg-zebra" role="progressbar" style="width: 75%;" aria-valuenow="50"
                aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="d-flex justify-content-between position-absolute w-100" style="top: -10px;">
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-zebra text-white d-flex align-items-center justify-content-center"
                  style="width: 35px; height: 35px;">
                  <i class="fas fa-plane-departure small"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Datos de viaje</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-zebra text-white d-flex align-items-center justify-content-center"
                  style="width: 35px; height: 35px;">
                  <i class="fas fa-calculator small"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Cotizar</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-zebra text-white d-flex align-items-center justify-content-center"
                  style="width: 35px; height: 35px;">
                  <i class="fas fa-shopping-cart small"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Comprar</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style="width: 35px; height: 35px;">
                  <i class="fas fa-check small text-muted"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Finalizar</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12 mb-12">
          <div class="bg-white rounded-lg shadow-lg p-4">
            <div style="margin-bottom: 1rem">
              <DetalleCompra :cotizar="cotizar"></DetalleCompra>
            </div>

            <h3 class="font-weight-bold mb-4 text-zebra text-start"><strong> Información de Pago </strong></h3>

            <form @submit.prevent="processPayment" class="payment-form">
              <!-- Step 1: Método de pago (ahora primero) -->
              <div v-if="currentStep === 1" class="mb-4">
                <h6 class="mb-3">Método de Pago</h6>
                <div class="mb-3">
                  <label class="form-label">Tipo de Pago *</label>
                  <select class="form-select" v-model="formData.payment_method.type" required>
                    <option :value="i.id" v-for="i in tipoPago" :key="i.id">{{ i.name }}</option>
                  </select>
                </div>

                <div v-if="formData.payment_method.type === 'CARD'" class="card-details mt-3">
                  <div class="mb-3">
                    <label class="form-label">Número de Tarjeta *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="cardData.number"
                      maxlength="16"
                      required
                      placeholder="007806050070XXXX"
                    >
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-3">
                      <label class="form-label">Mes (MM) *</label>
                      <input 
                        type="text" 
                        class="form-control"
                        v-model="cardData.exp_month"
                        maxlength="2"
                        required
                        placeholder="08"
                      >
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Año (YY) *</label>
                      <input 
                        type="text" 
                        class="form-control"
                        v-model="cardData.exp_year"
                        maxlength="2"
                        required
                        placeholder="28"
                      >
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">CVC *</label>
                      <input 
                        type="text" 
                        class="form-control"
                        v-model="cardData.cvc"
                        maxlength="4"
                        required
                        placeholder="123"
                      >
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Número de cuotas</label>
                      <select class="form-select" v-model="formData.payment_method.installments" required>
                        <option v-for="cuota in 24" :key="cuota" :value="cuota">{{ cuota }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Nombre del Titular *</label>
                    <input 
                      type="text" 
                      class="form-control"
                      v-model="cardData.card_holder"
                      required
                      placeholder="José Pérez"
                    >
                  </div>
                </div>

                <div v-if="formData.payment_method.type === 'NEQUI'">
                  <div class="mb-3">
                    <label class="form-label">Numero de Celular *</label>
                    <input type="text" class="form-control" placeholder="3XXXXXXXXX" v-model="formData.payment_method.phone_number">
                  </div>
                </div>

                <div v-if="formData.payment_method.type === 'PSE'">
                  <h6 class="mb-3">Formulario PSE</h6>
                  <div class="mb-3">
                    <label class="form-label">Tipo de Persona *</label>
                    <select class="form-select" v-model="formData.payment_method.user_type" required>
                      <option value="0">Natural</option>
                      <option value="1">Jurídica</option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Tipo de Documento *</label>
                    <select class="form-select" v-model="formData.payment_method.user_legal_id_type" required>
                      <option value="CC">Cédula de Ciudadanía</option>
                      <option value="NIT">NIT</option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Número de Documento *</label>
                    <input type="text" class="form-control" v-model="formData.payment_method.user_legal_id" required placeholder="Ingrese su número de documento" />
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Selecciona la Institución Financiera *</label>
                    <select class="form-select" v-model="formData.payment_method.financial_institution_code" id="listBank" required>
                      <option v-for="opcion in financial_institutions" :key="opcion.financial_institution_code" :value="opcion.financial_institution_code">
                        {{ opcion.financial_institution_name }}
                      </option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Descripción del Pago *</label>
                    <input type="text" class="form-control" v-model="formData.payment_method.payment_description" required maxlength="64" placeholder="Descripción del pago" />
                  </div>
                </div>

                <!-- Resumen del pago -->
                <div class="mb-4">
                  <h6 class="mb-3">Resumen del Pago</h6>
                  <div class="bg-light p-3 rounded">
                    <p class="mb-2">Total a pagar: {{ formatAmount(amountInCents) }}</p>
                    <p class="mb-0 small text-muted">Referencia: {{ reference }}</p>
                  </div>
                </div>

                <!-- Botón para continuar al siguiente paso -->
                <div class="d-flex justify-content-end gap-2">
                  <button type="button" class="btn btn-secondary" @click="showModal = false">
                    Cancelar
                  </button>
                  <button type="button" class="btn btn-zebra" @click="nextStep">
                    Continuar
                  </button>
                </div>
              </div>

              <!-- Step 2: Datos del cliente (ahora segundo) -->
              <div v-if="currentStep === 2" class="mb-4">
                <h6 class="mb-3">Datos de Facturación</h6>
                <div class="mb-3">
                  <label class="form-label">Correo Electrónico *</label>
                  <input type="email" class="form-control" v-model="formData.customer_email" required placeholder="ejemplo@correo.com">
                </div>

                <div class="mb-3">
                  <label class="form-label">Nombre Completo *</label>
                  <input type="text" class="form-control" v-model="formData.customer_data.full_name" required>
                </div>

                <div class="row mb-3">
                  <div class="col-md-6">
                    <label class="form-label">Tipo de Documento *</label>
                    <select class="form-select" v-model="formData.customer_data.legal_id_type" required>
                      <option value="CC">Cédula de Ciudadanía</option>
                      <option value="CE">Cédula de Extranjería</option>
                      <option value="PP">Pasaporte</option>
                      <option value="NIT">NIT</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Número de Documento *</label>
                    <input 
                      type="text" 
                      class="form-control"
                      v-model="formData.customer_data.legal_id"
                      required
                    >
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">Teléfono *</label>
                  <input 
                    type="tel" 
                    class="form-control"
                    v-model="formData.customer_data.phone_number"
                    required
                    placeholder="+573001234567"
                  >
                </div>

                <!-- Términos y condiciones -->
                <div class="mb-4">
                  <div class="form-check">
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      v-model="termsAccepted" 
                      id="termsCheck" 
                      required
                    >
                    <label class="form-check-label" for="termsCheck">
                      Acepto los <a :href="merchants?.data.presigned_acceptance?.permalink" target="_blank" class="text-zebra">
                        términos y condiciones
                      </a>
                      del servicio *
                    </label>
                  </div>
                </div>

                <!-- Resumen del pago (repetido para mejor contexto) -->
                <div class="mb-4">
                  <h6 class="mb-3">Resumen del Pago</h6>
                  <div class="bg-light p-3 rounded">
                    <p class="mb-2">Total a pagar: {{ formatAmount(amountInCents) }}</p>
                    <p class="mb-0 small text-muted">Referencia: {{ reference }}</p>
                  </div>
                </div>

                <!-- Botones para regresar o confirmar -->
                <div class="d-flex justify-content-end gap-2">
                  <button type="button" class="btn btn-secondary" @click="previousStep">
                    Regresar
                  </button>
                  <button type="submit" class="btn btn-zebra">
                    Confirmar Pago
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref } from 'vue'
import DetalleCompra from '@/components/components/DetalleCompra';
import Header from '@/components/components/Header';

import Swal from 'sweetalert2';

export default {
  components: {
    DetalleCompra,
    Header
  },

  setup() {
    const showModal = ref(false)
    return {
      showModal
    }
  },

  data() {
    return {
      currentStep: 1, // Nuevo: para controlar los pasos del formulario
      isProcessing: false,
      qrDisplayed: false,
      collectInfoDisplayed: false,
      formData: {
        customer_email: '',
        customer_data: {
          legal_id: '',
          full_name: '',
          phone_number: '',
          legal_id_type: 'CC'
        },
        payment_method: {
          type: 'BANCOLOMBIA_TRANSFER',
          user_type: 'PERSON',
          payment_description: 'Pago a Tienda Wompi',
          sanbox_status: 'APROVED',
          financial_institution_code : 0
        }
      },
      tipoPago: [],
      termsAccepted: false,
      merchants: null,
      amountInCents: 0,
      reference: 'pedido-' + Date.now(),
      acceptance_token: 'eyJhbGciOiJIUzI1NiJ9...', // Tu token real aquí
      order: {},
      cotizar: {},
      cardData: {
        number: '',
        exp_month: '',
        exp_year: '',
        cvc: '',
        card_holder: ''
      },
      cardToken: null,
      selectedOption: 'default',
      phoneNumber: '',
      financial_institutions : []
    }
  },

  async mounted() {
    this.merchants = await this.$root.getMerchants();

    this.financial_institutions = await this.$root.getInstitucionesFinancieras();

    this.tipoPago = [
      { name: "Tarjeta de credito o Debito", id: "CARD"},
      { name: "Boton Bancolombia", id: "BANCOLOMBIA_TRANSFER"},
      { name: "Nequi", id: "NEQUI"},
      //{ name: "DaviPlata", id: "DAVIPLATA"},
      { name: "PSE", id: "PSE"},
      //{ name: "Pago por QR", id: "BANCOLOMBIA_QR"}, 
      //{ name: "Pago en Efectivo", id: "BANCOLOMBIA_COLLECT"}
    ]
    this.acceptance_token = this.merchants.data.presigned_acceptance.acceptance_token;

    this.order = JSON.parse(localStorage.getItem('order'))
    this.cotizar = JSON.parse(localStorage.getItem('cotizar'));
    this.cotizar = JSON.parse(localStorage.getItem('cotizar'));
    this.amountInCents = Math.round((this.cotizar.plan.pvp * this.cotizar.noDias * this.cotizar.trm * 100) / this.cotizar.noDias);
    // this.amountInCents = Math.round((this.cotizar.plan?.pvp * this.cotizar.noDias * this.cotizar.trm) * 100);
    if (
      this.cotizar?.plan?.pvp != null &&
      this.cotizar?.trm != null &&
      this.cotizar?.plan?.unit != null
    ) {
      if (this.cotizar.plan.unit === 'bloques') {
        this.amountInCents = Math.round(this.cotizar.plan.pvp * this.cotizar.trm * 100);
      } else {
        const noDias = this.cotizar.noDias ?? 1; // fallback a 1 si no está definido
        this.amountInCents = Math.round((this.cotizar.plan.pvp * noDias * this.cotizar.trm * 100)/noDias);
      }
    } else {
      console.warn('Datos incompletos para calcular amountInCents');
      this.amountInCents = 0;
    }

    // Redondea al valor entero más cercano sin los centavos
    this.amountInCents = Math.floor(this.amountInCents / 100) * 100;
  },

  methods: {
    // Métodos para navegar entre pasos
    nextStep() {
      if (this.formData.payment_method.type === 'CARD') {
        this.validateCard();
      } else {
        this.currentStep = 2;
      }
    },
    
    previousStep() {
      this.currentStep = 1;
    },
    
    formatAmount(cents) {
      const amount = cents / 100
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP'
      }).format(amount)
    },

    async validateCard() {
        this.$root.postCardToken(this.cardData).then(response => {
          if (response.status === "ERROR") {
            Swal.fire({
              title: 'Error',
              text: response.error.message,
              icon: 'error',
              confirmButtonText: 'Ok'
            });
            return;
          }
          this.cardToken = response.data.data.id;
          this.formData.payment_method.token = this.cardToken;
          this.currentStep = 2;

        }).catch(err => {
          const errors = err.response.data.error.error.messages
          let messages = '';
          if (errors.number) {
            messages += "El número de tarjeta debe tener entre 12 y 19 dígitos.";
          }
          if (errors.exp_month) {
            messages += "El mes de expiración debe tener 2 dígitos.";
          }
          if (errors.exp_year) {
            messages += "El año de expiración debe tener 2 dígitos.";
          }
          if (errors.cvc) {
            messages += "El CVC debe tener entre 3 y 4 dígitos.";
          }
          if (errors.card_holder) {
            messages += "El nombre del titular debe tener al menos 5 caracteres.";
          }
          Swal.fire({
              title: 'Error',
              text: messages,
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          
        });
    },

    async formatErrorMessage(errors) {
      let messages = '';
      if (errors.number) {
        messages += "El número de tarjeta debe tener entre 12 y 19 dígitos.";
      }
      if (errors.exp_month) {
        messages += "El mes de expiración debe tener 2 dígitos.";
      }
      if (errors.exp_year) {
        messages += "El año de expiración debe tener 2 dígitos.";
      }
      if (errors.cvc) {
        messages += "El CVC debe tener entre 3 y 4 dígitos.";
      }
      if (errors.card_holder) {
        messages += "El nombre del titular debe tener al menos 5 caracteres.";
      }
      
      return messages;
    },

    async processPayment() {
      try {
        // Show loading state
        this.isProcessing = true;
        
        Swal.fire({
          title: 'Procesando pago',
          html: 'Por favor espere mientras procesamos su transacción...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        
        const paymentData = {
          acceptance_token: this.acceptance_token,
          amount_in_cents: this.amountInCents,
          currency: 'COP',
          customer_email: this.formData.customer_email,
          reference: this.reference,
          customer_data: this.formData.customer_data,
          payment_method: this.formData.payment_method
        }

        // Si es pago con tarjeta, incluir el token
        switch (paymentData.payment_method.type) {
          case 'CARD':
            paymentData.payment_method.token = this.cardToken;
            break;
          case 'PSE':
            paymentData.payment_method.payment_description = "Pago a Tienda Wompi, ref: " + paymentData.reference
            break;
          case 'BANCOLOMBIA_COLLECT':
            paymentData.payment_method.sandbox_status = "APPROVED";
            break;
          case 'BANCOLOMBIA_QR':
            paymentData.payment_method.sandbox_status = "APPROVED";
            paymentData.payment_method.payment_description = "APPROVED";
            break;
          case 'DAVIPLATA':
            paymentData.payment_method.payment_description = "Pago a Tienda Wompi, ref: " + paymentData.reference;
            paymentData.payment_method.user_legal_id = paymentData.customer_data.legal_id;
            paymentData.payment_method.user_legal_id_type = paymentData.customer_data.legal_id_type;
            paymentData.payment_method.type = "DAVIPLATA";
            delete paymentData.customer_data;
            delete paymentData.payment_method.financial_institution_code;
            delete paymentData.payment_method.sanbox_status;
            delete paymentData.payment_method.user_type;
            break;
        }

        if(paymentData.payment_method.type == 'BANCOLOMBIA_TRANSFER' || paymentData.payment_method.type == 'PSE') {          
          const data = {
            order: JSON.parse(localStorage.getItem('order')), // Asegúrate de serializar los datos
            payment: paymentData
          };
          const response = await this.$root.dataJsonTransaccional(data);
          if(response.status == 'ok') {
            Swal.close();
            window.open(`https://wtapruebas.zebrasistencia.com/pago-externo?reference=${ response.referenceCode }`, '_blank');          
            window.location.href = '/';
          }else {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al procesar su pago. Por favor intente nuevamente.',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
            this.isProcessing = false;
          }             

        }else {
            const res = await this.$root.postTransaction(paymentData);
            if (res.status == "ERROR") {
              Swal.fire({
                title: 'Error',
                text: res.error.message,
                icon: 'error',
                confirmButtonText: 'Ok'
              });
              this.isProcessing = false;
            } else {
                // Start monitoring transaction status for other payment methods
              this.monitorTransactionStatus(res.data.data.id);

            }            
            this.showModal = false;
        }                
        
      } catch (error) {
        console.error('Error al procesar el pago:', error);
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al procesar su pago. Por favor intente nuevamente.',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
        this.isProcessing = false;
      }
    },

    async monitorTransactionStatus(transactionId) {
      try {
        // Define maximum attempts and interval (10 seconds between checks, max 30 attempts = 5 minutes)
        const maxAttempts = 30;
        let attempts = 0;

        // Start the polling interval
        const statusCheckInterval = setInterval(async () => {
          attempts++;
          try {
            const transaction = await this.$root.getTransaction(transactionId);
            if (transaction.status === "ERROR") {
              clearInterval(statusCheckInterval);
              Swal.fire({
                title: 'Error',
                text: transaction.error.message,
                icon: 'error',
                confirmButtonText: 'Ok'
              });
              this.isProcessing = false;
              return;
            }
            const type = this.formData.payment_method.type;
            const transactionStatus = transaction.data.status;
            const paramsTransferencia = {
              json: JSON.stringify(this.order),
              id_transaccion: transactionId
            }
            
            // Handle different payment methods and their specific flows
            if (type === 'BANCOLOMBIA_TRANSFER' || type === 'PSE') {
              if (transaction.data.payment_method.extra?.async_payment_url) {
                clearInterval(statusCheckInterval);
                this.$root.saveTransaccion(paramsTransferencia).then(report => {
                  if (report.status == "ERROR") {
                    alert(report.error.message)
                  } else {
                    window.location.href = transaction.data.payment_method.extra.async_payment_url;
                  }
                });

                this.$router.push('/planes');
                return;
              }

            } else if (type === 'BANCOLOMBIA_COLLECT' && !this.collectInfoDisplayed) {
              // Display collect info for BANCOLOMBIA_COLLECT payments once
              this.collectInfoDisplayed = true;
              this.$root.saveTransaccion(paramsTransferencia).then(report => {
                if (report.status == "ERROR") {
                  alert(report.error.message)
                } else {
                  Swal.fire({
                    title: 'Información de Pago',
                    html: `Por favor acérquese al corresponsal Bancolombia más cercano con estos datos: <br>
                          <strong>Número de convenio:</strong> ${transaction.data.payment_method.extra.business_agreement_code} <br>
                          <strong>Número de pago:</strong> ${transaction.data.payment_method.extra.payment_intention_identifier}
                          <p class="mt-3">El estado de su transacción se está verificando...</p>`,
                    icon: 'info',
                    showConfirmButton: true,
                    confirmButtonText: 'Confirmar',
                    allowOutsideClick: false
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.href = '/';
                    }
                  });
                }
              });
            } else if (type === 'BANCOLOMBIA_QR' && !this.qrDisplayed) {
              // Display QR code for BANCOLOMBIA_QR payments once
              this.qrDisplayed = true;
              Swal.fire({
                title: 'Pago con código QR',
                html: `<p>Escanee el código QR para completar su pago:</p>
                      <img src="data:image/svg+xml;base64,${transaction.data.payment_method.extra.qr_image}" 
                          alt="Imagen QR" style="width: 250px; height: 250px;">
                      <p class="mt-3">El estado de su transacción se está verificando...</p>`,
                icon: 'info',
                showConfirmButton: true,
                confirmButtonText: 'Confirmar',
                allowOutsideClick: false
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = '/';
                }
              });
            } else if (type === 'NEQUI' && !this.nequiDisplayed) {
              // Display NEQUI info for NEQUI payments once
              this.nequiDisplayed = true;
              this.$root.saveTransaccion(paramsTransferencia).then(report => {
                if (report.status == "ERROR") {
                  alert(report.error.message)
                } else {
                  Swal.fire({
                    title: 'Pago con NEQUI',
                    html: `<p>🔔 Atención: Recibirás una notificación push de Nequi en tu celular.
                                 Por favor, acepta o rechaza la transacción desde esa notificación.
                                 El resultado se verá reflejado automáticamente en nuestro sistema en pocos segundos.
                               <br/> 
                              ✅ Importante: Si no ves la notificación, abre la app de Nequi para revisar y autorizar manualmente :</p>`,
                    icon: 'info',
                    showConfirmButton: true,
                    confirmButtonText: 'Confirmar',
                    allowOutsideClick: false
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.href = '/';
                    }
                  });
                }
              })
            }


            // Process based on transaction status
            if (transactionStatus === 'APPROVED') {
              clearInterval(statusCheckInterval);
              
              if (type === 'CARD') {
                // For CARD payments only, show loading message and create order
                Swal.fire({
                  title: 'Pago Exitoso',
                  text: 'Su pago ha sido aprobado. Estamos procesando su orden...',
                  icon: 'success',
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  }
                });
                // Create the order
                await this.createOrderAndRedirect(transactionId);
              }
              return;
            } else if (transactionStatus === 'DECLINED' || transactionStatus === 'ERROR' || transactionStatus === 'VOIDED') {
              // Payment failed
              clearInterval(statusCheckInterval);
              Swal.fire({
                title: 'Transacción Fallida',
                text: `Estado de la transacción: ${transactionStatus}. Por favor intente con otro método de pago.`,
                icon: 'error',
                confirmButtonText: 'Ok'
              });
              this.isProcessing = false;
              return;
            }
            // If we've reached max attempts, stop checking
            if (attempts >= maxAttempts) {
              clearInterval(statusCheckInterval);
              Swal.fire({
                title: 'Tiempo de espera excedido',
                text: 'La verificación de su pago está tomando más tiempo del esperado. Puede verificar el estado de su orden más tarde.',
                icon: 'warning',
                confirmButtonText: 'Ok'
              });
              this.isProcessing = false;
            }
            
          } catch (err) {
            console.error('Error checking transaction status:', err);
            // Continue checking despite error
          }
        }, 10000); // Check every 10 seconds
      } catch (error) {
        console.error('Error monitoring transaction:', error);
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al verificar el estado de su transacción.',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
        this.isProcessing = false;
      }
    },


  async createOrderAndRedirect(transactionId) {
    try {
      // Update order with transaction ID
      this.order.transactionId = transactionId;
      this.order.payment_method_type = 'CARD';
      this.order.customer_email = this.formData.customer_email;
      this.order.legal_id = this.formData.customer_data.legal_id;
      this.order.legal_id_type = this.formData.customer_data.legal_id_type;
      this.order.full_name = this.formData.customer_data.full_name;
      this.order.phone_number = this.formData.customer_data.phone_number;
      
      // Create the order
      const orderRes = await this.$root.post('orders/create', this.order);
      
      if (orderRes.status === "ERROR") {
        Swal.fire({
          title: 'Error',
          text: orderRes.error.message,
          icon: 'error',
          confirmButtonText: 'Ok'
        });
        this.isProcessing = false;
        return;
      }
      const voucherCode = orderRes.data.data.voucherCode[0];

      // Save order to localStorage
      localStorage.setItem("order", JSON.stringify(this.order));
      
      // Close any open modals
      Swal.close();
      
      // Redirect to voucher page
      this.$router.push(`/voucher/${voucherCode}`);
      
    } catch (error) {
      console.error('Error creating order:', error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al procesar su orden. Por favor contacte a soporte.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      this.isProcessing = false;
    }
  },


    createOrder() {
      this.$root.post(`orders/create`, this.order).then(res => {
        if (res.status == "ERROR") {
          alert(res.error.message)
        } else {
          // localStorage.setItem("order", JSON.stringify(this.order));
          const report = {
            ...this.order,
            code: res.data.voucherCode
          }
          this.$root.post(`orders/report`, report).then(report => {
            if (report.status == "ERROR") {
              alert(report.error.message)
            } else {
              localStorage.setItem("order", JSON.stringify(this.order));
            }
          });
        }
      });
    },

    async getTransations(id) {
      this.$root.getTransaction(id).then(transaction => {
        if (transaction.status == "ERROR") {
          Swal.fire({
            title: 'Error',
            text: transaction.error.message,
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        } else {
          const type = this.formData.payment_method.type
          if (type == 'BANCOLOMBIA_TRANSFER' || type ==  'PSE') {
            if (transaction.data.payment_method.extra.async_payment_url) {
              window.location.href = transaction.data.payment_method.extra.async_payment_url;
            } else {
              this.getTransations(id);
            }
          } else {
            if (type == 'CARD') {
              if (transaction.data.status == 'APPROVED') {
                this.createOrder()
                Swal.fire({
                  title: 'El pago se aceptó correctamente, un asesor ',
                  text: 'Su tarjeta puede que aun este en validacion.',
                  icon: 'success',
                  confirmButtonText: 'Ok'
                });
              }
            } else if (type == 'BANCOLOMBIA_QR') {
              Swal.fire({
                icon: 'success',
                confirmButtonText: 'Ok',
                html: `<img src="data:image/svg+xml;base64,${transaction.data.payment_method.extra.qr_image}" alt="Imagen QR" style="width: 400px; height: 300px;">`
              });
            } else if (type == 'BANCOLOMBIA_COLLECT') {
              Swal.fire({
                title: transaction.data.status,
                html: `Por favor acerquese a la sucursal bancolombia mas cercana con estos datos, <br>
                      Número de convenio: ${transaction.data.payment_method.extra.business_agreement_code} <br>
                      Número de pago: ${transaction.data.payment_method.extra.payment_intention_identifier}`,
                icon: 'success',
                confirmButtonText: 'Ok'
              });
            }
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
}

.btn-zebra {
  background-color: #20c997;
  color: white;
}

.btn-zebra:hover {
  background-color: #17a2b8;
}

.form-label {
  font-weight: 500;
}

.text-zebra {
  color: #20c997;
  text-decoration: none;
}

.text-zebra:hover {
  text-decoration: underline;
}

.form-check-input:checked {
  background-color: #20c997;
  border-color: #20c997;
}
</style>